import { useContestAgreementDetail } from "./useContestAgreementDetail";
import { ContestAgreementDetail } from "@/types/contestAgreement";

export function useContestAgreementData(id: string): ContestAgreementDetail {
  const { query } = useContestAgreementDetail(id);

  if (query.isLoading || query.isPending) {
    throw new Error("Contest agreement data is still loading");
  }
  if (query.error) {
    throw query.error;
  }
  if (!query.data) {
    throw new Error("No contest agreement data available");
  }

  return query.data;
}
